import service from "@/utils/http";
// 登录
export function login(data){
    return service({
     url:"User/Login",
     method:"post",
     data
    })
 };


// WEBPACK FOOTER //
// ./src/api/login.js